import { useEffect, useState } from "react";
import { userService } from "../services";
import { IUser } from "../interfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const limit = 10;
const List = () => {
  const [page, setPage] = useState(1);
  const [searchParam, setSearchParam] = useState("");
  const [searchClass, setSearchClass] = useState("w-200");
  const [type, setType] = useState("anarestan");
  const [duration, setDuration] = useState("month");
  const [users, setUsers] = useState<IUser[]>([]);
  const [showSearch, setShowSearch] = useState(true);

  useEffect(() => {
    function getList(): void {
      userService.getList(duration, page, limit, type).then((res: IUser[]) => {
        setUsers(res);
      });
    }
    getList();
    // eslint-disable-next-line
  }, []);

  const getUsers = (_duration: string, _page: number, _type: string) => {
    userService.getList(_duration, _page, limit, _type).then((res: IUser[]) => {
      setUsers(res);
      setPage(_page);
      setDuration(_duration);
      setType(_type);
    });
  };
  const search = () => {
    setShowSearch(false);
    userService.search(duration, searchParam).then(
      (res: IUser[]) => {
        setUsers(res);
      },
      (error: string) => {
        notify();
      }
    );
  };
  const changeDuration = (_newduration: string) => {
    const _duration = _newduration;
    getUsers(_duration, page, type);
  };
  const updatePage = (type: string) => {
    const _page = type === "+" ? page + 1 : page - 1;
    getUsers(duration, _page, type);
  };
  const updateType = (_type: string) => {
    getUsers(duration, page, _type);
  };
  const closeSearch = () => {
    getUsers(duration, page, type);
    setSearchParam("");
    setShowSearch(true);
    setSearchClass("w-200");
  };
  const updateSearchParam = (_searchParam: string) => {
    setSearchParam(_searchParam);
    setShowSearch(true);
  };
  const expand = () => {
    setSearchClass("w-500");
  };
  const notify = () => toast("کاربری با ایمیل یا موبایل وارد شده یافت نشد!");
  return (
    <section className="main-content">
      <ToastContainer />
      <div className="container">
        <div className="search-box input-group">
          <div className="form-outline">
            <input
              type="text"
              id="usr"
              value={searchParam}
              placeholder="Search box"
              className={searchClass}
              onClick={expand}
              onChange={(e) => updateSearchParam(e.target.value)}></input>
          </div>
          {showSearch ? (
            <button className="search-btn" onClick={search}>
              <FontAwesomeIcon icon={faSearch} />
            </button>
          ) : (
            <button className="search-btn" onClick={closeSearch}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>

        <div className="row">
          <div className="col-md-6 col-xs-12">
            <button
              onClick={() => updateType("anarestan")}
              className={`anarestan ${type === "anarestan" ? "selected" : ""}`}>
              کاربران انارستانی
            </button>
            <button
              onClick={() => updateType("all")}
              className={`anarestan ${type === "anarestan" ? "" : "selected"}`}>
              همه کاربران
            </button>
          </div>

          <div className="col-md-6 col-xs-12 text-end">
            <button
              onClick={() => changeDuration("week")}
              className={`duration weekly ${
                duration === "week" ? "selected" : ""
              }`}>
              هفتگی
            </button>
            <button
              onClick={() => changeDuration("month")}
              className={`duration ${duration === "month" ? "selected" : ""}`}>
              {" "}
              ماهانه
            </button>
            <button
              onClick={() => changeDuration("year")}
              className={`duration yearly ${
                duration === "year" ? "selected" : ""
              }`}>
              سالانه
            </button>
          </div>
        </div>
        <div className="list-table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Photo</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Level</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              {users?.map((user: IUser) => {
                let avatar = require("../assets/img/default-user.png");
                let pomegranate = require("../assets/img/pomegranate.png");
                return (
                  <tr key={user.index}>
                    <td>
                      <div className="col-index">
                        <h4 className="mr-1">{user.index}</h4>
                        {user.is_anarestan ? (
                          <img
                            key={`icon-${user.index}`}
                            src={pomegranate}
                            alt="user icon"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          key={user.index}
                          src={user.avatar ? user.avatar : avatar}
                          className="circle-img circle-img--small mr-2"
                          alt={user.mobile ? user.mobile : user.email}
                        />
                      </div>
                    </td>
                    <td>
                      {user.first_name} {user.last_name}
                    </td>
                    <td>{user.mobile ? user.mobile : "-"}</td>
                    <td>{user.email ? user.email : "-"}</td>
                    <td>{user.level_name ? user.level_name : "-"}</td>
                    <td>{user.duration}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="col-md-12 text-center">
            <button
              className="paging prev"
              onClick={() => updatePage("_")}
              disabled={page <= 1}>
              Prev
            </button>
            <span className="paging current">Page: {page}</span>
            <button
              className="paging next"
              onClick={() => updatePage("+")}
              disabled={users && users.length < limit}>
              Next
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default List;
